import React, { useState } from 'react';

import { useField } from 'formik';

import { twMerge } from 'tailwind-merge';

import type { AvatarProps } from 'components-new/avatar/avatar';
import Avatar from 'components-new/avatar/avatar';
import Typography from 'components-new/typography/typography';

const createImageURL = (file: Blob | MediaSource) => {
  return file ? URL.createObjectURL(file) : null;
};

interface AvatarFieldProps extends AvatarProps {
  name: string;
  title?: string;
  className?: string;
  titleClassName?: string;
  avatarClassName?: string;
  errorClassName?: string;
}

const AvatarField: React.FC<AvatarFieldProps> = ({
  name,
  title,
  className,
  avatarClassName,
  titleClassName,
  errorClassName,
}) => {
  const [field, meta, helpers] = useField(name);
  const [preview, setPreview] = useState<string | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      helpers.setValue(file);
      setPreview(createImageURL(file));
    }
  };

  const titleClassNames = twMerge('mb-2', titleClassName);
  const errorClassnames = twMerge('text-destructive mt-1', errorClassName);

  return (
    <div className={className}>
      {title && (
        <Typography
          as="p"
          variant="body-medium-bold"
          className={titleClassNames}
        >
          {title}
        </Typography>
      )}

      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor={name}>
        <Avatar
          name=""
          image={preview || field.value}
          className={avatarClassName}
        />
      </label>

      <input
        id={name}
        name={name}
        type="file"
        onChange={handleChange}
        accept="image/*"
        style={{ display: 'none' }}
      />

      {!!meta.touched && !!meta.error && (
        <Typography as="p" variant="body-medium" className={errorClassnames}>
          {meta.error}
        </Typography>
      )}
    </div>
  );
};

export default AvatarField;
